import * as Sentry from '@sentry/react';
import { config } from './lib/env-helpers';
import { ignoreSentryErrors } from '@shared/utils/sentry/sentry.helper';
export { setSentryUser } from './shared/utils/sentry/sentry.helper';
export type { SentryUserInput } from './shared/utils/sentry/sentry.helper';

// Attaches tracing headers on outgoing requests so it can link frontend activity with backend performance.
const TRACE_PROPAGATION_TARGET = (() => {
  try {
    return new URL(config?.API_ENDPOINT)?.host;
  } catch {
    return '';
  }
})();
export const isSentryEnabled = config.IS_UAT || config.IS_PRODUCTION;

export function initSentry() {
  if (isSentryEnabled) {
    Sentry.init({
      dsn: config.SENTRY_DSN,
      // Setting this option to true will send default PII (Personally Identifiable Information) data to Sentry.
      // For example, automatic IP address collection on events
      sendDefaultPii: true,
      integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
      // Tracing
      // It should be 0.1 during production
      tracesSampleRate: 0.2, //  Capture 100% of the transactions
      // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
      tracePropagationTargets: ['localhost', TRACE_PROPAGATION_TARGET],
      // Session Replay
      replaysSessionSampleRate: 0.0, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
      replaysOnErrorSampleRate: 0.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.,
      // Enable logs to be sent to Sentry
      enableLogs: true,
      enabled: true,
      environment: config.APP_ENV,
      release: config.APP_VERSION,
      beforeSend: ignoreSentryErrors,
    });
  }
}
